var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { SelfService } from 'src/app/bpg-self-services/self-services.service.ts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BpgAdminServices } from '../../bpg-admin/bpg-admin-services';
import { BpgCommonService } from 'src/app/bpg-common/services/bpg-common.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
var UserMembershipComponent = /** @class */ (function () {
    function UserMembershipComponent(bpgCommonService, spinner, selfService, adminService, router, dialog) {
        this.bpgCommonService = bpgCommonService;
        this.spinner = spinner;
        this.selfService = selfService;
        this.adminService = adminService;
        this.router = router;
        this.dialog = dialog;
        this.isbrowseChapterSelected = true;
        this.ismyMembershipSelected = false;
        this.siteList = [];
        // nativeSiteId: any;
        // nativeSiteName: string;
        this.bpgList = [];
        this.regularBpgList = [];
        this.virtualBpgList = [];
        this.selectedBpg = [];
        this.loginData = JSON.parse(localStorage.getItem('loginData'));
        this.enrolledBpg = [];
        this.removeMemberships = [];
        this.userEmail = '';
        this.emailAddress = '';
        this.isEmailInvalid = false;
        this.noMembershipsFound = false;
        this.emailSent = false;
        this.membershipsUpdated = false;
        this.isEmailEditable = false;
    }
    UserMembershipComponent.prototype.ngOnInit = function () {
        this.userId = this.loginData['userId'];
        this.userEmail = sessionStorage.getItem('emailAddressForMembership');
        if (this.userEmail == "" || this.userEmail == null || this.userEmail == undefined ||
            !(this.userEmail.endsWith('@toyota.com') || this.userEmail.endsWith('@lexus.com') || this.userEmail.endsWith('@scion.com'))) {
            this.isEmailEditable = true;
        }
        this.logUserAction();
        this.getEnrolledBpgs();
        // this.getAllSite();
        this.getRegularAndVirtualBpgs();
    };
    UserMembershipComponent.prototype.getRegularAndVirtualBpgs = function () {
        var _this = this;
        this.spinner.show();
        this.selfService.getVirtualBpgs(this.userId).subscribe(function (data) {
            _this.spinner.hide();
            if (data != null && data != undefined) {
                if (data['regularMemberships']) {
                    var regularMemberships = data['regularMemberships'];
                    if (regularMemberships.bpgList) {
                        _this.regularBpgList = regularMemberships.bpgList;
                        _this.siteId = regularMemberships.siteId;
                        _this.siteName = regularMemberships.siteName;
                        _this.isDefaultSite = _this.siteName == 'DEFAULT SITE LOCATION' ? true : false;
                        if (_this.regularBpgList.length > 0) {
                            _this.regularBpgList.map(function (res) {
                                res.siteId = _this.siteId;
                                res.siteName = _this.siteName;
                            });
                        }
                    }
                }
                if (data['virtualMemberships']) {
                    _this.virtualBpgList = data['virtualMemberships'];
                    // console.log(virtualMemberships)
                    // if(virtualMemberships.bpgList)
                    // {
                    //   this.virtualBpgList = virtualMemberships;
                    // this.siteId = virtualMemberships.siteId;
                    // this.siteName = virtualMemberships.siteName;
                    // if(this.virtualBpgList.length > 0)
                    // {
                    // this.virtualBpgList.map(res => {
                    //           res.isEnrolled = false;
                    //         })
                    // }
                    //}
                }
            }
        });
    };
    UserMembershipComponent.prototype.selectChapter = function (data) {
        this.disableButton = true;
        var bpg = JSON.parse(JSON.stringify(data));
        this.virtualBpgList.map(function (res) {
            if (res.bpgId == bpg.bpgId) {
                res.checked = true;
            }
        });
        this.virtualMembershipBpgIdSelected = bpg.bpgId;
        this.bpgsiteList = [];
        this.bpgsiteList = bpg.siteDetails;
        this.bpgsiteList.forEach(function (res) {
            res.bpgId = bpg.bpgId;
            res.bpgName = bpg.bpgName;
        });
        var dialogConfig = new MatDialogConfig();
        dialogConfig.minHeight = "30vh";
        dialogConfig.maxHeight = "60vh";
        dialogConfig.width = "50vw";
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        var dialogRef = this.dialog.open(this.callAPIDialog, dialogConfig);
        dialogRef.updatePosition({
            top: '27vh',
        });
    };
    UserMembershipComponent.prototype.toggleRadio = function (data) {
        this.disableButton = false;
        this.selectedChapter = data;
    };
    UserMembershipComponent.prototype.confirmVirtualMembership = function () {
        var _this = this;
        this.selectedBpg.map(function (res) {
            if (res.bpgName == _this.selectedChapter.bpgName) {
                _this.selectedBpg.splice(_this.selectedBpg.indexOf(res), 1);
            }
        });
        this.virtualBpgList.map(function (res) {
            if (res.bpgId == _this.selectedBpg.bpgId) {
                res.checked = true;
            }
        });
        this.selectedBpg.push(this.selectedChapter);
        console.log(this.selectedBpg);
        var dialogRef = this.dialog.closeAll();
    };
    UserMembershipComponent.prototype.closePopup = function () {
        var _this = this;
        this.virtualBpgList.map(function (res) {
            if (res.bpgId == _this.virtualMembershipBpgIdSelected) {
                res.checked = false;
            }
        });
        var dialogRef = this.dialog.closeAll();
    };
    // getAllSite() {
    //   this.spinner.show();
    //   let siteData = {
    //     "filter": {},
    //     "moduleId": 0,
    //     "page": 0,
    //     "presentRole": "string",
    //     "searchTerm": "string",
    //     "size": 0,
    //     "sortDirection": "ASC",
    //     "sortProperty": "string",
    //     "uid": "string"
    //   }
    //   // this.selfService.getMembershipSites(this.userId).subscribe(data =>
    //   this.bpgCommonService.getSiteList(siteData).subscribe(data => {
    //     this.siteList = data;
    //     if (data) {
    //       // this.siteList = this.siteList.filter(site => site.locationCode !== 'DFLT');
    //       this.siteList.map(res => {
    //         if (localStorage.getItem("userSiteId") == res.siteId) {
    //           this.isDefaultSite = res.locationCode === 'DFLT' ? true : false;
    //           this.siteId = res.siteId;
    //           this.siteName = res.siteName;
    //           if(!this.isDefaultSite)
    //           { 
    //             this.getAllBpg(this.siteId);
    //           }
    //         }
    //       })
    //     }
    //     //filter default site from sitelist
    //   })
    // }
    UserMembershipComponent.prototype.getEnrolledBpgs = function () {
        var _this = this;
        this.noMembershipsFound = false;
        this.selfService.getEnrolledBpg(this.userId).subscribe(function (data) {
            if (data != null && data != undefined) {
                if (data.length == 0) {
                    _this.noMembershipsFound = true;
                }
                else {
                    _this.enrolledBpg = data;
                    _this.enrolledBpg.map(function (res) {
                        res.viewSite = true;
                        if (res.isBaseSite) {
                            _this.regularMembershipsExists = true;
                        }
                        else {
                            _this.virtualMembershipsExists = true;
                        }
                    });
                }
            }
        });
    };
    // getAllBpg(siteId) {
    //   this.ownSite = localStorage.getItem('userSiteId') == siteId ? true : false;
    //   // this.noBpgsFound = false;
    //   this.siteList.map(res => {
    //     if (siteId == res.siteId) {
    //       this.siteId = res.siteId;
    //       this.siteName = res.siteName;
    //     }
    //   })
    //   this.spinner.show();
    //   this.selfService.getNotEnrolledBpg(this.siteId, this.userId).subscribe(data => {
    //     if (data.length == 0) {
    //       // this.noBpgsFound = true;
    //       this.spinner.hide();
    //     }
    //     if (data != null && data != undefined) {
    //       this.regularBpgList = data;
    //       this.regularBpgList.map(res => {
    //         res.siteId = this.siteId;
    //         res.siteName = this.siteName;
    //         res.chair = false;
    //         res.viceChair = false;
    //         res.communicationChair = false;
    //         res.financeChair = false;
    //       })
    //     }
    //     // if (this.selectedBpg.length > 0 && this.regularBpgList.length > 0) {
    //     //   this.selectedBpg.map(res => {
    //     //     this.regularBpgList.map(res1 => {
    //     //       if (res.bpgId == res1.bpgId && res.siteId != res1.siteId) {
    //     //         this.regularBpgList.splice(this.regularBpgList.indexOf(res1), 1);
    //     //       }
    //     //     })
    //     //   })
    //     // }
    //     // if (this.bpgList.length == 0) {
    //     //   this.noBpgsFound = true;
    //     // } else {
    //     //   this.bpgList.map(res => {
    //     //     res.chair = false;
    //     //     res.viceChair = false;
    //     //     res.communicationChair = false;
    //     //     res.financeChair = false;
    //     //   })
    //     // }
    //     this.spinner.hide();
    //     // if (this.bpgList.length > 0 && this.selectedBpg.length > 0) {
    //     //   var filteredBpgList = []
    //     //   var filteredselectedBpg = []
    //     //   this.bpgList.map(a => {
    //     //     if (a.siteId == this.siteId) {
    //     //       filteredBpgList.push(a)
    //     //     }
    //     //   })
    //     //   this.selectedBpg.map(b => {
    //     //     if (b.siteId == this.siteId) {
    //     //       filteredselectedBpg.push(b)
    //     //     }
    //     //   })
    //     //   filteredselectedBpg.map(res => {
    //     //     filteredBpgList.map(res1 => {
    //     //       if (res.bpgId == res1.bpgId) {
    //     //         res1.chair = res.chair;
    //     //         res1.viceChair = res.viceChair
    //     //         res1.financeChair = res.financeChair
    //     //         res1.communicationChair = res.communicationChair
    //     //         res1.showLeadership = true
    //     //       }
    //     //     })
    //     //   })
    //     // }
    //   })
    // }
    UserMembershipComponent.prototype.removeMembership = function (data, data1) {
        this.method = "onRemoveMembership";
        this.param = data;
        this.param1 = data1;
        this.msg = " Are you sure you want to cancel the membership ? ";
    };
    UserMembershipComponent.prototype.onRemoveMembership = function () {
        var _this = this;
        this.enrolledBpg.map(function (sample3) {
            if (sample3.siteId === _this.param1) {
                var sample2 = sample3.bpgList.filter(function (list) { return list.bpgId === _this.param; });
                sample3 = __assign({}, sample3, { bpgList: sample2 });
                _this.removeMemberships.push(sample3);
            }
        });
        this.enrolledBpg = this.enrolledBpg.map(function (sample) {
            if (sample.siteId === _this.param1) {
                var sample1 = sample.bpgList.filter(function (list) { return list.bpgId !== _this.param; });
                sample = __assign({}, sample, { bpgList: sample1 });
            }
            return sample;
        });
        this.regularMembershipsExists = false;
        this.virtualMembershipsExists = false;
        this.enrolledBpg.map(function (res) {
            if (res.isBaseSite && res.bpgList.length > 0) {
                _this.regularMembershipsExists = true;
            }
            if (!res.isBaseSite && res.bpgList.length > 0) {
                _this.virtualMembershipsExists = true;
            }
        });
    };
    UserMembershipComponent.prototype.showHideChapterMembership = function (data) {
        this.enrolledBpg.map(function (res) {
            if (res.siteName == data) {
                res.viewSite = !res.viewSite;
            }
        });
    };
    /** to select the checkbox
   * @class BpgListComponent
   * @method toggleCheckbox
   */
    UserMembershipComponent.prototype.toggleCheckbox = function (event, data, regularOrVirtual) {
        var _this = this;
        var bpg = JSON.parse(JSON.stringify(data));
        if (event.target.checked) {
            if (regularOrVirtual == 'regular') {
                this.selectedBpg.push(bpg);
                this.regularBpgList.map(function (a) {
                    if (a.bpgName == bpg.bpgName) {
                        a = Object.assign(a, {
                            'showLeadership': true,
                            'siteId': _this.siteId,
                            'siteName': _this.siteName
                        });
                    }
                });
                this.selectedBpg.map(function (res) {
                    if (bpg.bpgId == res.bpgId && res.siteId == _this.siteId) {
                        res.chair = false;
                        res.viceChair = false;
                        res.communicationChair = false;
                        res.financeChair = false;
                    }
                });
            }
            else {
                this.selectChapter(bpg);
            }
        }
        else {
            var index_1 = -1;
            this.selectedBpg.map(function (res) {
                if (data.bpgId == res.bpgId) {
                    index_1 = _this.selectedBpg.indexOf(res);
                }
            });
            if (index_1 !== -1) {
                this.selectedBpg.splice(index_1, 1);
                if (regularOrVirtual == 'regular') {
                    this.regularBpgList.map(function (a) {
                        if (a.bpgName == bpg.bpgName) {
                            a = Object.assign(a, {
                                'showLeadership': false,
                                'siteId': _this.siteId,
                                'siteName': _this.siteName
                            });
                        }
                    });
                    this.regularBpgList.map(function (res) {
                        if (data.bpgId == res.bpgId && res.siteId == _this.siteId) {
                            res.chair = false;
                            res.viceChair = false;
                            res.communicationChair = false;
                            res.financeChair = false;
                        }
                    });
                }
                else {
                    this.virtualBpgList.map(function (res) {
                        if (res.bpgId == bpg.bpgId) {
                            res.checked = false;
                        }
                    });
                }
            }
        }
    };
    /** email validation
   * @class ChapterComponent
   * @method checkEmailType
   */
    UserMembershipComponent.prototype.checkEmailType = function (event) {
        if (event.target.value != "") {
            var re = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
            if (re.test(String(event.target.value).toLowerCase()) == false) {
                this.isEmailInvalid = true;
            }
            else {
                this.isEmailInvalid = false;
            }
        }
        else {
            this.isEmailInvalid = false;
        }
    };
    UserMembershipComponent.prototype.updateEmail = function () {
        var _this = this;
        this.createdDateTime = new Date();
        this.modifiedDateTime = new Date();
        var landingData = {
            // "createdBy": this.userId,
            // "createdDateTime": this.createdDateTime,
            // "isActive": true,
            // "modifiedBy": this.userId,
            // "modifiedDateTime": this.modifiedDateTime,
            "userId": this.userId,
            "personalemailId": this.emailAddress,
        };
        this.adminService.updateMembershipEmail(landingData).subscribe(function (data) {
            if (data != null && data != undefined) {
                _this.emailSent = true;
                _this.userEmail = _this.emailAddress;
                _this.editEmailAllowed = false;
                setTimeout(function () {
                    this.emailSent = false;
                }.bind(_this), 2500);
            }
        });
    };
    UserMembershipComponent.prototype.browseChapters = function () {
        this.isbrowseChapterSelected = true;
        this.ismyMembershipSelected = false;
    };
    UserMembershipComponent.prototype.myMemberships = function () {
        this.isbrowseChapterSelected = false;
        this.ismyMembershipSelected = true;
    };
    UserMembershipComponent.prototype.selectChapterMembership = function (bpg, data, virtualOrRegular) {
        var _this = this;
        this.selectedBpg.map(function (res) {
            if (res.bpgId == bpg.bpgId && res.siteId == _this.siteId) {
                // virtualOrRegular == 'regular' ? res.siteName = this.siteId : this.siteName;
                if (data == 'chair') {
                    res.chair = !res.chair;
                }
                if (data == 'viceChair') {
                    res.viceChair = !res.viceChair;
                }
                if (data == 'financeChair') {
                    res.financeChair = !res.financeChair;
                }
                if (data == 'communicationChair') {
                    res.communicationChair = !res.communicationChair;
                }
            }
        });
        this.regularBpgList.map(function (res) {
            if (res.bpgId == bpg.bpgId && res.siteId == _this.siteId) {
                res.siteName = _this.siteName;
                if (data == 'chair') {
                    res.chair = !res.chair;
                }
                if (data == 'viceChair') {
                    res.viceChair = !res.viceChair;
                }
                if (data == 'financeChair') {
                    res.financeChair = !res.financeChair;
                }
                if (data == 'communicationChair') {
                    res.communicationChair = !res.communicationChair;
                }
            }
        });
    };
    UserMembershipComponent.prototype.undoRemoveMembership = function (bpg, siteId) {
        var _this = this;
        this.enrolledBpg = this.enrolledBpg.map(function (sample) {
            if (sample.siteId === siteId) {
                sample.bpgList.push(bpg);
            }
            return sample;
        });
        this.removeMemberships = this.removeMemberships.map(function (sample) {
            if (sample.siteId === siteId) {
                var sample1 = sample.bpgList.filter(function (list) { return list.bpgId !== bpg.bpgId; });
                sample = __assign({}, sample, { bpgList: sample1 });
            }
            return sample;
        });
        this.removeMemberships = this.removeMemberships.filter(function (res) {
            return res.bpgList.length > 0;
        });
        this.regularMembershipsExists = false;
        this.virtualMembershipsExists = false;
        this.enrolledBpg.map(function (res) {
            if (res.isBaseSite && res.bpgList.length > 0) {
                _this.regularMembershipsExists = true;
            }
            if (!res.isBaseSite && res.bpgList.length > 0) {
                _this.virtualMembershipsExists = true;
            }
        });
    };
    UserMembershipComponent.prototype.editEmail = function () {
        this.editEmailAllowed = true;
        this.emailAddress = this.userEmail;
    };
    UserMembershipComponent.prototype.saveMembership = function () {
        var _this = this;
        this.spinner.show();
        var submitData = {
            userId: this.userId,
            'addMembership': this.selectedBpg,
            'removeMembership': this.removeMemberships
        };
        this.selfService.saveMembership(submitData).subscribe(function (data) {
            if (data != null && data != undefined) {
                _this.spinner.hide();
                _this.membershipsUpdated = true;
                // this.isEmailEditable = false;
                _this.selectedBpg = [];
                _this.removeMemberships = [];
                // this.getAllBpg(localStorage.getItem('userSiteId'));
                _this.getEnrolledBpgs();
                _this.getRegularAndVirtualBpgs();
                window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
                setTimeout(function () {
                    _this.membershipsUpdated = false;
                    _this.ismyMembershipSelected = true;
                    _this.isbrowseChapterSelected = false;
                }, 1000);
                // this.router.navigate(['/membership/preview-success']);
            }
        });
    };
    UserMembershipComponent.prototype.logUserAction = function () {
        var data = {
            userId: this.userId,
            categoryDescription: "Membership Application"
        };
        this.bpgCommonService.logUserAction(data).subscribe(function (_data) { });
    };
    return UserMembershipComponent;
}());
export { UserMembershipComponent };
